import { Injectable } from '@angular/core';
import { AbstractFilterService } from './abstract-filter.service';

@Injectable()
export class DocumentFilterService extends AbstractFilterService {
  constructor() {
    super();
  }
}
